// extracted by mini-css-extract-plugin
module.exports = {"root":"ManageButton_root__24665"};